import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import Image from 'src/components/image'
import loaderSrc from 'src/assets/phone-loader.svg'

export class BrowserContainer extends Component {
  static propTypes = {
    className: PropTypes.string,
    src: PropTypes.any,
    alt: PropTypes.string,
    delay: PropTypes.number,
    forceIndex: PropTypes.number,
    children: PropTypes.any,
    showLoader: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    src: '',
    alt: 'Browser Content',
    delay: 1500,
    forceIndex: null,
    children: null,
    showLoader: false,
  }

  state = {
    index: 0,
  }

  get className() {
    const { className } = this.props
    return c('browser-container', className)
  }

  get sources() {
    const { src } = this.props
    return Array.isArray(src) ? src : [src]
  }

  componentDidMount = () => {
    this.mounted = true
    const { sources } = this
    const { delay } = this.props
    if (sources.length < 2) return
    const interval = setInterval(this.fade, delay)
    this.setState({ interval: interval })
  }

  fade = () => {
    if (!this.mounted) return
    const currentIndex = this.state.index
    const { sources } = this
    let nextIndex = currentIndex + 1
    if (nextIndex > sources.length - 1) nextIndex = 0
    this.setState({ index: nextIndex })
  }

  componentDidUpdate = prevProps => {
    const { forceIndex } = this.props
    if (typeof prevProps.forceIndex !== 'number' && typeof forceIndex === 'number') {
      clearInterval(this.state.interval)
      this.setState({ interval: null, index: forceIndex })
    }
    if (typeof prevProps.forceIndex === 'number' && typeof forceIndex !== 'number') {
      const { sources } = this
      const { delay } = this.props
      if (sources.length < 2) return
      const interval = setInterval(this.fade, delay)
      this.setState({ interval: interval })
    }
  }

  componentWillUnmount = () => {
    this.mounted = false
    clearInterval(this.state.interval)
  }

  render() {
    const { className, sources } = this
    const { alt, children, showLoader } = this.props
    const { index } = this.state
    return (
      <div className={className}>
        <div className="image-container">
          {sources.map((src, i) => (
            <img
              key={`${i}-src`}
              className={c('device-content', index !== i && 'asset-hidden')}
              src={src}
              alt={alt}
            />
          ))}
          {showLoader && (
            <div className="loader">
              <Image className="loader-circle" src={loaderSrc} alt="Browser Loader" />
            </div>
          )}
          {children}
        </div>
      </div>
    )
  }
}

export default BrowserContainer
